import { OrganizationCodes, CorporateCard } from '@revenuemarket/bank';
import { AccountStatus } from '@revenuemarket/trade';
import { API } from '~apis/axios/instance';
import { AccountType } from '~models/bank/enum';
import { ResponseBaseWithData } from '~types/response';

export interface OrganizationResponse {
  banks: IBanksItem[];
  securities: ISecuritiesItem[];
  cards: ICardOrgItem[];
  homeTax: IHomeTax;
  homeTaxes: IHomeTaxItem[];
}

export interface ISecuritiesItem {
  organizationCode: OrganizationCodes;
  connected: boolean;
  accounts: IAccountsItemForSecurities[];
}

export interface IBanksItem {
  organizationCode: OrganizationCodes;
  connected: boolean;
  accounts: IAccountsItem[];
}

interface IAccountsItem {
  alias: string;
  bankAccountId: number;
  displayAccountNumber: string;
  status: AccountStatus;
  type: AccountType;
  isPurged: boolean;
  originalAlias: string;
}

export interface IAccountsItemForSecurities {
  id: number;
  companyId: string;
  organizationCode: string;
  accountStatusCode: AccountStatus;
  needPassword: boolean;
  hasPassword: boolean;
  account: string;
  accountDisplay: string;
  accountName: string;
  accountNickName: string;
  createdAt: string;
  updatedAt: string;
  alias: string;
  originalAlias: string;
  isPurged: boolean;
}

export interface ICardOrgItem {
  organizationCode: OrganizationCodes;
  connected?: boolean;
  loginTypes?: string[];
  cards?: CorporateCard[];
}

export interface IHomeTax {
  connected: boolean;
}

export interface IHomeTaxItem {
  companyName: string | null;
  businessRegistrationNumber: string | null;
  connected: boolean;
}

/**
 * 인증 기관 정보 조회 API
 * @link https://apollo11.dev2.clobe.ai/swagger-ui/index.html#/company-organizations-controller/list_7
 * @param companyId
 * @returns
 */
export function getOrganizationsInfo(companyId: string) {
  return API.get<ResponseBaseWithData<OrganizationResponse>>(
    `/api/v3/companies/${companyId}/organizations`,
  );
}
